import {useImages} from "../contexts/images";
import {textColorField, type FieldColors, type ElementColors} from "../libs/sceneColors";

/** Read one field from the authoritative scene color record. */
export function useFieldColor(type: string, id: string) {
  const {fieldColors, elementColors} = useImages() as {fieldColors: Record<string, FieldColors>; elementColors: Record<string, ElementColors>};
  const field = textColorField(type);
  return {color: field === null ? undefined : fieldColors[id]?.[field],
    cascade: Object.hasOwn(fieldColors, id) || Object.hasOwn(elementColors, id)};
}
